"use strict";
var __spreadArrays = (this && this.__spreadArrays) || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++)
        for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++)
            r[k] = a[j];
    return r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.ClientEvent = void 0;
exports.ClientEvent = {
    /**
     * USAGE:
     *
     * In Client:
     * import {EventClient} from "../../util/eventClient";
     * EventClient.emit("type", payload);
     *
     * In Component that you wish to fire an event in:
     * import {EventClient} from "../../../util/eventClient";
     * componentWillMount() {
     *   EventClient.on(EventClientTypes, instanceKey, () => this.saveExternal());
     * }
     *
     * componentWillUnmount() {
     *   EventClient.off(EventClientTypes, instanceKey, () => this.saveExternal());
     * }
     */
    events: {},
    /**
     * Adds the @listener function to the end of the listeners array
     * for the event named @eventName
     * Will ensure that only one time the listener added for the event
     *
     * @param event
     * @param instanceKey
     * @param {function} listener
     */
    on: function (event, instanceKey, listener) {
        if (instanceKey == null)
            return;
        if (!this.events[event])
            this.events[event] = [];
        var newEvents = [];
        this.events[event].forEach(function (event) {
            if (event['instance'] !== instanceKey)
                newEvents.push(event);
        });
        this.events[event] = newEvents;
        this.events[event].push({ listener: listener, instance: instanceKey });
    },
    /**
     * Will remove the specified @listener from @event list
     *
     * @param event
     * @param instanceKey
     * @param {function} listener
     */
    off: function (event, instanceKey) {
        if (instanceKey == null)
            return;
        if (!this.events[event])
            return;
        var newEvents = [];
        this.events[event].forEach(function (event) {
            if (event['instance'] !== instanceKey)
                newEvents.push(event);
        });
        this.events[event] = newEvents;
    },
    /**
     * Adds the @listener function to the end of the listeners array
     * for the event named @eventName
     * Will provide an unsubscribe to remove the listener without an instanceKey
     *
     * @param event
     * @param {function} listener
     */
    subscribe: function (event, listener) {
        var _this = this;
        if (!this.events[event])
            this.events[event] = [];
        var listenerWrap = {
            listener: listener,
            instance: null,
        };
        this.events[event].push(listenerWrap);
        return {
            unsubscribe: function () {
                if (!_this.events[event])
                    return;
                _this.events[event].splice(_this.events[event].indexOf(listenerWrap) >>> 0, 1);
            }
        };
    },
    /**
     * Will emit the event on the event name with the @payload
     * and if its an error set the @error value
     *
     * @param {string} event
     * @param data
     */
    // publish(event: string | number, ...data: any): void,
    emit: function (event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        if (!this.events[event])
            return;
        this.events[event].forEach(function (callback) { return callback.listener.apply(callback, data); });
    },
    publish: function (event) {
        var data = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            data[_i - 1] = arguments[_i];
        }
        this.emit.apply(this, __spreadArrays([event], data));
    },
    /**
     * Will clear the event list
     */
    clearAll: function () {
        this.events = {};
    }
};
